module.exports = __webpack_public_path__ + "img/海南大学.ea32d6c6.jpg";